export default "__VITE_ASSET__BhDfflHQ__"